<template>
  <div id="app">
    <el-container>
      <el-header height="80px">
        <app-header></app-header>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer height="400px">
        <app-footer></app-footer>
      </el-footer>
      <!-- 在所有页面底部显示悬浮按钮 -->
      <floating-contact-buttons />
    </el-container>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  created() {
    // 初始化 store
    this.$store.dispatch('initializeStore')
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/fonts/font.css'); /* 引入字体规则 */
#app {
  font-family: 'montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;  
  color: var(--text-color);
}

.el-header {
  padding: 0;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

// 使用 :deep() 修改 el-main 的 padding
:deep(.el-main) {
  // 可根据需求修改 padding 值
  padding: 0px; 
  min-height: calc(100vh - 480px);
}

.el-footer {
  padding: 40px 0;
  background-color: #f5f7fa;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
}
</style> 
